import styled from "styled-components";

export const StyledHeader = styled.div`
/* Style for "Enter your" */
min-height: 110px;
color: #0b0b0b;
font-family: "Lato-Light";
font-size: 21px;
font-weight: normal;
margin: 40px 0px 20px;

span{
    -webkit-animation: fadein 0.7s; /* Safari, Chrome and Opera > 12.1 */
       -moz-animation: fadein 0.7s; /* Firefox < 16 */
        -ms-animation: fadein 0.7s; /* Internet Explorer */
         -o-animation: fadein 0.7s; /* Opera < 12.1 */
            animation: fadein 0.7s;
}


@keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}
`;
